import { render, staticRenderFns } from "./TagTable.vue?vue&type=template&id=cb0a4468&scoped=true"
import script from "./TagTable.vue?vue&type=script&lang=js"
export * from "./TagTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0a4468",
  null
  
)

export default component.exports